(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

/*
 * Coast Cards (30 Sept 2026): with the cart set to Page, take the shopper to the cart
 * as soon as an item is added, so they see it went in and can check out.
 * Does nothing when the cart is set to Drawer. Remove this block to go back to Horizon's default.
 */
(function coastCardsGoToCart() {
  document.addEventListener('shopify:cart:lines-update', async function (event) {
    if (event.action !== 'add' || !event.promise) return;
    if (document.querySelector('cart-drawer-component')) return;
    if (/\/cart\/?$/.test(window.location.pathname)) return;
    try {
      const result = await event.promise;
      if (result && result.detail && result.detail.didError === false) {
        const cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
        window.location.href = cartUrl;
      }
    } catch (error) {
      // Add to cart failed; the theme shows its own error message.
    }
  });
})();
